import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import * as React from 'react';
import type { UseFormRegister } from 'react-hook-form';

interface BuildComponent {
  lbl: string;
  name?: string;
  i: { v: string | number; c: string | number; lbl: string }[];
}

interface CustomDropdownProps {
  buildComponent: BuildComponent;
  register: UseFormRegister<any>;
}

export const CustomDropdown: React.FC<CustomDropdownProps> = ({ buildComponent, register }) => {
  const [currentValue, setCurrentValue] = React.useState<string | number>('');
  const registration = buildComponent?.name ? register(buildComponent.name, { required: true }) : undefined;

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    setCurrentValue(event.target.value);
    registration?.onChange(event);
  };

  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel>{buildComponent.lbl}</InputLabel>
      <Select
        labelId="demo-select-small"
        id="demo-select-small"
        value={currentValue}
        label={buildComponent.lbl}
        onChange={handleChange}
        onBlur={registration?.onBlur}
        inputRef={registration?.ref}
        name={buildComponent?.name}>
        <MenuItem value="">
          <em> </em>
        </MenuItem>
        {buildComponent.i.map((item) => {
          const { v, c, lbl } = item;
          return (
            <MenuItem value={v} key={c}>
              {lbl}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
